<template>
  <div class="basic_information_box">
    <Card dis-hover>
      <template #title>
        <div class="options_box">
          <h2>{{ $t('key1002511') }}</h2>
          <Button type="primary" v-if="!hideSave && getPermission('ymsPackageRuleDetails_save')" @click="packageRuleDetailsSave">{{ $t('key1000555') }}</Button>
        </div>
      </template>
      <Form ref="formInline" class="delaration_form" :model="formInline" :rules="ruleInline" :disabled="isDisabled" label-position="top" size="small" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="oneItemCol">
            <Form-item :label="$t('key1002506')">
              <RadioGroup v-model="declareQuantityType">
                <Radio label="0">{{ $t('key1002512') }}</Radio>
                <Radio label="1">{{ $t('key1002513') }}</Radio>
                <InputNumber
                  v-if="declareQuantityType === '1'"
                  :disabled="declareQuantityType === '0'"
                  :max="999999999"
                  :min="1"
                  size="small"
                  v-model="declareQuantity">
                </InputNumber>
              </RadioGroup>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol">
            <FormItem :label="$t('key1002507')">
              <RadioGroup v-model="goodsQuantityType">
                <Radio label="0">{{ $t('key1002514') }}</Radio>
                <Radio label="1">{{ $t('key1002515') }}</Radio>
                <InputNumber
                  v-if="goodsQuantityType === '1'"
                  :disabled="goodsQuantityType === '0'"
                  :max="999999999"
                  :min="1"
                  size="small"
                  v-model="goodsQuantity">
                </InputNumber>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol">
            <FormItem :label="$t('key1002508')">
              <Select v-model="formInline.sortMethod" style="width: 300px;" size="small" filterable>
                <Option v-for="(item,index) in sortMethodList" :key="index" :value="item.value">{{ item.label }}</Option>
              </Select>
              <span class="redColor">{{ $t('key1002516') }}</span>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol">
            <FormItem :label="$t('key1002509')">
              <RadioGroup v-model="formInline.weightType">
                <div>
                  <Radio label="F">{{ $t('key1002517') }}</Radio>
                  {{ $t('key1002518') }}
                  <InputNumber
                    style="margin: 0 5px;"
                    :disabled="formInline.weightType === 'R'"
                    :max="999999999"
                    :min="1"
                    size="small"
                    v-model="formInline.fixWeight">
                  </InputNumber>
                  g
                  <span class="redColor">{{ $t('key1002519') }}</span>
                </div>
                <div>
                  <Radio label="R">{{ $t('key1002520') }}</Radio>
                  <Checkbox
                    :disabled="formInline.weightType === 'F'" v-model="isSetMaxWeight">{{ $t('key1002521') }}
                    <InputNumber
                      v-model="formInline.maxWeight"
                      :disabled="formInline.weightType === 'F' || !isSetMaxWeight"
                      :max="999999999"
                      size="small"
                      :min="0">
                    </InputNumber>
                    <span class="font-size-14 ml5">g</span>
                  </Checkbox>
                </div>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol">
            <FormItem :label="$t('key1002510')">
              <div>
                <span class="txtStyle">{{ $t('key1002522') }}</span>
                <Select style="width: 300px;" v-model="formInline.declareCurrency" size="small" filterable>
                  <Option v-for="(item, index) in currencyList" :key="index" :value="item.value">{{ item.label }}</Option>
                </Select>
              </div>
              <RadioGroup v-model="formInline.priceType">
                <div>
                  <Radio label="F">{{ $t('key1002523') }}</Radio>
                  {{ $t('key1002524') }}
                  <InputNumber
                    class="leftStyle"
                    :disabled="formInline.priceType === 'R'"
                    :max="999999999"
                    :min="1"
                    size="small"
                    v-model="formInline.fixAmount">
                  </InputNumber>
                  <span class="redColor">{{ $t('key1002525') }}</span>
                </div>
                <div>
                  <Radio label="R">{{ $t('key1002526') }}</Radio>
                  {{ $t('key1002527') }}
                  <Select :disabled="formInline.priceType === 'F'" filterable class="leftStyle" style="width: 100px;" v-model="formInline.amountFrom" size="small">
                    <Option v-for="(item,index) in amountFromList" :key="index" :value="item.value">{{ item.label }}</Option>
                  </Select>
                  <span class="leftStyle">{{ $t('key1002528') }}</span>
                  <InputNumber
                    class="leftStyle"
                    :disabled="formInline.priceType === 'F'"
                    :max="999999999"
                    :min="1"
                    size="small"
                    v-model="formInline.amountPercentage">
                  </InputNumber>
                  <span class="leftStyle">%</span>
                  <Checkbox
                    class="leftStyle"
                    v-model="isSetMinAmount" :disabled="formInline.priceType === 'F'">
                    <span>{{ $t('key1002529') }}</span>
                    <InputNumber
                      class="leftStyle"
                      :disabled="formInline.priceType === 'F' || !isSetMinAmount"
                      :max="999999999"
                      :min="0"
                      size="small"
                      v-model="formInline.minAmount">
                    </InputNumber>
                  </Checkbox>
                  <Checkbox class="leftStyle" v-model="isSetMaxAmount" :disabled="formInline.priceType === 'F'">
                    <span>{{ $t('key1002530') }}</span>
                    <InputNumber
                      class="leftStyle"
                      :disabled="formInline.priceType === 'F' || !isSetMaxAmount"
                      :max="999999999"
                      :min="0"
                      size="small"
                      v-model="formInline.maxAmount">
                    </InputNumber>
                  </Checkbox>
                  <span class="redColor">{{ $t('key1002531') }}</span>
                </div>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Card>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import {getCurrencyData, getDataSetBatchList, getEnumList} from "@/utils/common";

export default {
  name: 'delarationdetail',
  mixins: [Mixin],
  props: {
    hideSave: {
      default: false,
      type: Boolean
    },
    isDisabled: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      isSetMaxWeight: false,
      isSetMinAmount: false,
      isSetMaxAmount: false,
      declareQuantityType: '1',
      declareQuantity: 1,
      goodsQuantityType: '1',
      goodsQuantity: 1,
      sortMethodList: [
        {
          value: '0',
          label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002496')
        },
        {
          value: '1',
          label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002497')
        },
        {
          value: '2',
          label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002498')
        },
        {
          value: '3',
          label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002499')
        },
        {
          value: '4',
          label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002500')
        },
        {
          value: '5',
          label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002501')
        }
      ],
      setMaxWeight: false,
      setMaxAmount: false,
      setMinAmount: false,
      formInline: {
        'declareQuantity': 1, // 申报货品数量(0为全部申报)
        'goodsQuantity': 1, //  每个SKU最多申报数量(0为实际数量) ,
        'sortMethod': '0', // 申报货品排序方式 ,
        'weightType': 'R', // 重量获取方式(F固定重量, R真实重量，限重在max_weight标识)
        'fixWeight': 0, // 固定最大重量(g) 大于0 ,
        'maxWeight': 0, // 最大重量(g) 0为不限制重量 ,
        'declareCurrency': 'CNY', // 申报价值币种
        'priceType': 'F', //  价值申报方式(F固价申报, R 按真实价值比例申报) ,
        'fixAmount': 5, // 固定申报价值 ,
        'amountFrom': 'S', // 金额取自总售价或总成本 ,S(seller总售价),C(cost总成本) ,
        'amountPercentage': 0, //  按总售价或总成本金额多少比例取值,存储除100以后实际值
        'minAmount': 0, // 申报价最小值0为不限制 ,
        'maxAmount': 0 // 申报价最大值0为不限制 ,
        // 'isDefault': 'Y' // 是否默认规则(N为特殊规则，Y为默认规则) ,
      },
      ruleInline: {},
      currencyList: [],
      enumData: []
    };
  },
  computed: {
    amountFromList() {
      const ENUM_KEY = 'YmsPackageRuleDetailAmountFromCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY);
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      let enumKeyList = ['YmsPackageRuleDetailAmountFromCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.currencyList = await getCurrencyData();
    },
    setParams() {
      let v = this;
      if (v.declareQuantityType === '0') {
        v.formInline.declareQuantity = 0;
      } else {
        v.formInline.declareQuantity = v.declareQuantity;
      }
      if (v.goodsQuantityType === '0') {
        v.formInline.goodsQuantity = 0;
      } else {
        v.formInline.goodsQuantity = v.goodsQuantity;
      }
      return v.formInline;
    },
    validMt() {
      let v = this;
      if (v.isSetMinAmount && v.isSetMaxAmount && v.formInline.minAmount >= v.formInline.maxAmount) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002502'));
        return false;
      }
      if (v.isSetMinAmount && v.formInline.minAmount === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002503'));
        return false;
      }

      if (v.isSetMaxAmount && v.formInline.maxAmount === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002504'));
        return false;
      }

      if (v.isSetMaxWeight && v.formInline.maxWeight === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002505'));
        return false;
      }
      return true;
    },
    packageRuleDetailsSave() {
      let v = this;
      let params = v.setParams();
      let valid = v.validMt();
      if (valid) {
        v.axios.post(api.post_ymsPackageRuleDetails_save, params).then(res => {
          if (res.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113'));
          }
        });
      }
    },
    reset() {
      this.$nextTick(() => {
        this.declareQuantityType = '1';
        this.goodsQuantityType = '1';
        this.declareQuantity = 1;
        this.goodsQuantity = 1;
        this.formInline = {
          'declareQuantity': 1, // 申报货品数量(0为全部申报)
          'goodsQuantity': 1, //  每个SKU最多申报数量(0为实际数量) ,
          'sortMethod': '0', // 申报货品排序方式 ,
          'weightType': 'R', // 重量获取方式(F固定重量, R真实重量，限重在max_weight标识)
          'fixWeight': 0, // 固定最大重量(g) 大于0 ,
          'maxWeight': 0, // 最大重量(g) 0为不限制重量 ,
          'declareCurrency': 'CNY', // 申报价值币种
          'priceType': 'F', //  价值申报方式(F固价申报, R 按真实价值比例申报) ,
          'fixAmount': 5, // 固定申报价值 ,
          'amountFrom': 'S', // 金额取自总售价或总成本 ,S(seller总售价),C(cost总成本) ,
          'amountPercentage': 0, //  按总售价或总成本金额多少比例取值,存储除100以后实际值
          'minAmount': 0, // 申报价最小值0为不限制 ,
          'maxAmount': 0 // 申报价最大值0为不限制 ,
          // 'isDefault': 'Y' // 是否默认规则(N为特殊规则，Y为默认规则) ,
        };
      });
    },
    setForm(data) {
      let v = this;
      v.formInline = data;
      if (v.formInline.declareQuantity === 0) {
        v.declareQuantityType = '0';
      } else {
        v.declareQuantityType = '1';
        v.declareQuantity = v.formInline.declareQuantity;
      }
      if (v.formInline.goodsQuantity === 0) {
        v.goodsQuantityType = '0';
      } else {
        v.goodsQuantityType = '1';
        v.goodsQuantity = v.formInline.goodsQuantity;
      }
      if (v.formInline.minAmount) {
        v.isSetMinAmount = true;
      }
      if (v.formInline.maxAmount) {
        v.isSetMaxAmount = true;
      }
      if (v.formInline.maxWeight) {
        v.isSetMaxWeight = true;
      }
    },
    getRuleDetails(id) {
      let v = this;
      v.axios.get(api.get_ymsPackageRuleDetails + id).then(res => {
        if (res.data.code === 0 && res.data.datas) {
          v.setForm(res.data.datas);
        }
      });
    },
    getPackageRuleDetails() {
      let v = this;
      v.axios.get(api.get_ymsPackageRuleDetails_default).then(res => {
        if (res.data.code === 0 && res.data.datas) {
          v.setForm(res.data.datas);
        }
      });
    }
  },
  watch: {
    isSetMaxWeight(value) {
      if (!value) {
        this.formInline.maxWeight = 0;
      }
    },
    isSetMinAmount(value) {
      if (!value) {
        this.formInline.minAmount = 0;
      }
    },
    isSetMaxAmount(value) {
      if (!value) {
        this.formInline.maxAmount = 0;
      }
    }
  },
};
</script>
<style lang="less" scoped>
.basic_information_box {
  .options_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .delaration_form {
    /deep/ .ivu-form-item {
      .ivu-form-item-label {
        font-size: 15px;
        color: #333;
        font-weight: bold;
      }
    }

    .txtStyle {
      display: inline-block;
      font-size: 14px;
      color: #666;
      font-weight: bold;
    }

    .redColor {
      color: #ff3300;
      display: inline-block;
    }

    .leftStyle {
      margin-left: 8px;
    }
  }
}
</style>
